<template>
    <div class="wrap">
        <listHeader
            :title="postData.maid > 0 ? '编辑专业' : '新增专业'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="父级专业"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-select
                                    v-decorator="['pid', {required: true, rules: [{ message: '选择父级专业' }], initialValue: ''}]">>
                                    <a-select-option value="">选择父级专业</a-select-option>
                                    <a-select-option v-for="(item, key) in config.major" :key="key" :value="item.maid">
                                        {{ item.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="专业名称"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入专业名称" v-decorator="['name', {rules: [{ required: true, max: 64, message: '请输入专业名称' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';

export default {
    components: {
        listHeader,
    },
    data() {
        return {
            scenario: 'majorCreate',
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'maid': '',
            },
            data: {},
            config: {},
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/major/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.maid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            pid: res.data.pid,
                            name: res.data.name,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.maid > 0) {
                            url = '/manage/major/edit';
                            values.maid = this.postData.maid;
                        } else {
                            url = '/manage/major/save';
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                this.$router.go(-1);
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
